import { NgModule } from '@angular/core';
import { NgxPamlightService } from './services/ngx-client.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [NgxPamlightService]
})
export class NgxPamlightModule {}
